<div class="container mt-4">
    <div class="row">


        <div class="col-lg-12">

            <div class="card">
                <div class=" card-header ">
                    <h5 class="font-medium election-title">📄 CCL of PDS Misutilization Opening Balance</h5>

                </div>
                <div class="card-body">


                    <form [formGroup]="targetForm">
                        <div class="row align-items-end">

                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                                    <option value="">--Select--</option>
                                    <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                                        {{ circle?.sCircleName }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                                    class="text-danger small">
                                    Circle office is required
                                </div>
                            </div>
                            <!-- Block Office -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="blockOffice">
                                    <option value="" selected>--Select--</option>
                                    <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                        {{ circle?.sBlockName }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                    class="text-danger small">
                                    block Office is required
                                </div>
                            </div>




                        </div>
                    </form>

                </div>
            </div>
        </div>



    </div>
    <div class="col-lg-12">
        <div class="card">
            <div class="d-flex justify-content-between card-header">
                <h5 class="font-medium m-0">📄Report</h5>

                <button type="button" class="btn btn-primary btn-sm" (click)="viewModel($event)"
                    *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">+ Add
                    Misutilization
                    Data </button>
            </div>
            <div class="card-body">
                <div class="table-responsive">


                    <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover"
                        [rows]="rows" [headerHeight]="80" [rowHeight]="100" [columnMode]="'force'" [scrollbarV]="true"
                        [scrollbarH]="true" [limit]="10">

                        <!-- ID Column -->
                        <ngx-datatable-column [width]="60" prop="id">
                            <ng-template ngx-datatable-header-template>
                                <div style="font-weight: bold; white-space: normal; text-align: center;">
                                    ID
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Society Name Column with Text Wrap -->
                        <ngx-datatable-column [width]="300" prop="sSocietyName">
                            <ng-template ngx-datatable-header-template>
                                <div style="font-weight: bold; white-space: normal;">
                                    Society Name
                                </div>
                            </ng-template>
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <div style="white-space: normal; word-wrap: break-word;">
                                    {{ row.sSocietyName }}
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Misutilization Since -->
                        <ngx-datatable-column [width]="150" prop="misutilizationSinceYear">
                            <ng-template ngx-datatable-header-template>
                                <div style="font-weight: bold; white-space: normal;">
                                    Year since the amount has been misutilized
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Offline Entries Month -->
                        <ngx-datatable-column [width]="130" prop="offlineEntriesMonth">
                            <ng-template ngx-datatable-header-template>
                                <div style="font-weight: bold; white-space: normal;">
                                    Offline entry upto
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Opening Balance -->
                        <ngx-datatable-column [width]="150" prop="openingBalance">
                            <ng-template ngx-datatable-header-template>
                                <div style="font-weight: bold; white-space: normal;">
                                    Opening Balance of misutilization Amount<br>(in ₹)
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Amount Recovered -->
                        <ngx-datatable-column [width]="150" prop="amountRecovered">
                            <ng-template ngx-datatable-header-template>
                                <div style="font-weight: bold; white-space: normal;">
                                    Amount Recovered<br>(in ₹)
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Amount Recovered -->
                        <ngx-datatable-column [width]="150" prop="amountRecovered">
                            <ng-template ngx-datatable-header-template>
                                <div style="font-weight: bold; white-space: normal;">
                                    Action
                                </div>
                            </ng-template>

                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <div style="white-space: normal; word-wrap: break-word;">
                                    <div class="d-flex align-items-center gap-1">
                                        <button type="button" class="btn btn-primary btn-sm" title="Click to Edit"
                                            (click)="editRow(row)"><i class="bi bi-pencil-square"></i></button>
                                        <button type="button" class="btn btn-success btn-sm" title="Click to Verify"
                                            *ngIf="this.UserDetails?.roleId ==13" data-bs-toggle="modal"
                                            data-bs-target="#verifyConfirmModal">
                                            <i class="bi bi-clipboard2-check"></i>
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm" title="Click to Delete"
                                            data-bs-toggle="modal" data-bs-target="#deleteConfirmModal"
                                            (click)="setDeleteIndex(row?.id)">
                                            <i class="bi bi-trash3"></i>
                                        </button>
                                    </div>
                                </div>
                            </ng-template>

                        </ngx-datatable-column>

                    </ngx-datatable>

                    <!-- Delete Confirmation Modal -->
                    <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                        aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                </div>
                                <div class="modal-body">
                                    Are you sure you want to delete this?
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                        (click)="cancelDelete()">Cancel</button>
                                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                        aria-label="Close" (click)="DeleteMisutilization(deleteIndex)">Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- verify Confirmation Modal -->
                    <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                        aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                </div>
                                <div class="modal-body">
                                    Are you sure you want to Verify?
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                        (click)="this.deleteIndex = 0;">Cancel</button>
                                    <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                        aria-label="Close" (click)="VerifyMisutilization(deleteIndex)">Verify</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Read More Model -->
            <div class="modal fade animate-fade" id="readMoreModal" tabindex="-1" aria-labelledby="readMoreModalLabel"
                aria-hidden="true">
                <div class="modal-dialog   modal-lg modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="readMoreModalLabel">📄Add CCL PDS Misutilization Data</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                (click)="closeModel()"></button>
                        </div>
                        <div class="modal-body">
                            <div class="row">

                                <div class="col-12">
                                    <form [formGroup]="pdsForm">
                                        <div class="row align-items-end">

                                            <!-- Block Office -->
                                            <div class="col-lg-6 col-md-6 mb-2">
                                                <label class="form-label">Block Office <span
                                                        class="text-danger">*</span></label>
                                                <select class="form-control" formControlName="blockOffice">
                                                    <option value="" selected>--Select--</option>
                                                    <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                                        {{ circle?.sBlockName }}
                                                    </option>
                                                </select>
                                                <div class="text-danger small" style="min-height: 1.25rem;">
                                                    <span
                                                        *ngIf="pdsForm.get('blockOffice')?.touched && pdsForm.get('blockOffice')?.invalid">
                                                        Block Office is required
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Defaulter Society -->
                                            <div class="col-lg-6 col-md-6 mb-2">
                                                <label class="form-label">Defaulter Society <span
                                                        class="text-danger">*</span></label>
                                                <select class="form-control" formControlName="defaulterSociety">
                                                    <option value="" selected>--Select--</option>
                                                    <option *ngFor="let society of societyList" [value]="society?.id">
                                                        {{ society?.name }}
                                                    </option>
                                                </select>
                                                <div class="text-danger small" style="min-height: 1.25rem;">
                                                    <span
                                                        *ngIf="pdsForm.get('defaulterSociety')?.touched && pdsForm.get('defaulterSociety')?.invalid">
                                                        Defaulter Society is required
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Misutilization Since Year -->
                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Misutilization Since Year <span
                                                        class="text-danger">*</span></label>
                                                <!-- <input class="form-control" type="number" formControlName="sinceYear" placeholder="Enter Year" /> -->
                                                <select class="form-control" formControlName="sinceYear"
                                                    (change)="onSinceYearChange($event)">
                                                    <option value="" selected>--Select--</option>
                                                    <option *ngFor="let years of financialYears"
                                                        [value]="years.startYear">
                                                        {{ years?.financialYear }}
                                                    </option>
                                                </select>
                                                <div class="text-danger small" style="min-height: 1.25rem;">
                                                    <span
                                                        *ngIf="pdsForm.get('sinceYear')?.touched && pdsForm.get('sinceYear')?.invalid">
                                                        This field is required
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Reporting Year (Offline Entry Year) -->
                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">Reporting Year (Offline Entry Year) <span
                                                        class="text-danger">*</span></label>
                                                <!-- <input class="form-control" type="number" formControlName="offilneEntryYear" placeholder="Enter Reporting Year" /> -->
                                                <select class="form-control" formControlName="offilneEntryYear"
                                                    placeholder="Enter Reporting Year"
                                                    (change)="onReportingYearChange($event)">
                                                    <option value="" selected>--Select--</option>
                                                    <option *ngFor="let years of reportingYears"
                                                        [value]="years?.startYear">
                                                        {{ years?.financialYear }}
                                                    </option>
                                                </select>
                                                <div class="text-danger small" style="min-height: 1.25rem;">
                                                    <span
                                                        *ngIf="pdsForm.get('offilneEntryYear')?.touched && pdsForm.get('offilneEntryYear')?.invalid">
                                                        This field is required
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- During Month -->
                                            <div class="col-lg-4 col-md-6 mb-2">
                                                <label class="form-label">During Month <span
                                                        class="text-danger">*</span></label>
                                                <!-- <input class="form-control" type="month" formControlName="duringMonth" placeholder="e.g., May 2025" /> -->
                                                <select class="form-control" formControlName="duringMonth">
                                                    <option value="" selected>--Select Month--</option>
                                                    <option *ngFor="let month of filteredMonths"
                                                        [value]="month?.iMonthId">
                                                        {{ month?.sMonthName }}
                                                    </option>
                                                </select>

                                                <div class="text-danger small" style="min-height: 1.25rem;">
                                                    <span
                                                        *ngIf="pdsForm.get('duringMonth')?.touched && pdsForm.get('duringMonth')?.invalid">
                                                        This field is required
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Misutilize Amount -->
                                            <div class="col-lg-6 col-md-6 mb-2">
                                                <label class="form-label">Balance as On (Misutilized Amount) <span
                                                        class="text-danger">*</span></label>
                                                <div class="input-group">
                                                    <span class="input-group-text">₹</span>
                                                    <input type="number" min="1" step="1" class="form-control"
                                                        formControlName="misUtilizeAmount" />
                                                </div>
                                                <div class="text-danger small" style="min-height: 1.25rem;">
                                                    <span
                                                        *ngIf="pdsForm.get('misUtilizeAmount')?.touched && pdsForm.get('misUtilizeAmount')?.invalid">
                                                        Please enter a valid natural number
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Amount Recovered -->
                                            <div class="col-lg-6 col-md-6 mb-2">
                                                <label class="form-label">Amount Recovered During Month <span
                                                        class="text-danger">*</span></label>
                                                <div class="input-group">
                                                    <span class="input-group-text">₹</span>
                                                    <input type="number" min="0" step="1" class="form-control"
                                                        formControlName="recoverAmount" />
                                                </div>
                                                <div class="text-danger small" style="min-height: 1.25rem;">
                                                    <span
                                                        *ngIf="pdsForm.get('recoverAmount')?.touched && pdsForm.get('recoverAmount')?.invalid">
                                                        Amount is required
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Submit Button -->
                                            <!-- <div class="col-lg-12 text-end mt-3">
                <button type="submit" class="btn btn-primary" [disabled]="pdsForm.invalid">
                  Get Report
                </button>
              </div> -->

                                        </div>
                                    </form>

                                </div>
                                <div class="modal-footer">
                                    <!-- <button type="button" class=",'.
                 btn btn-secondary" data-bs-dismiss="modal" (click)="hideViewMore()">Close</button> -->
                                    <div class="col-lg-12 text-end">
                                        <div class="d-flex align-items-center justify-content-end gap-2">
                                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                                (click)="[closeModel()]">Back</button>
                                            <button type="submit" class="btn btn-primary" [disabled]="pdsForm.invalid"
                                                (click)="onSubmit()">Save</button>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>